import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { AGENCY_QUERY_KEY } from '~/features/agencies/hooks/useGetAgencies'
import { supabaseApi } from '~/supabase/api'
import { Agency } from '~/supabase/types'

export type CreateAgencyData = Omit<Agency, 'id' | 'created_at' | 'should_notify' | 'country'>

export const useCreateAgency = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (data: CreateAgencyData) => {
      const { error } = await supabaseApi.from('sales_agencies').insert(data)
      if (error) {
        toast.error(error.message)
        throw error
      }

      toast.success('Agency created successfully')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [AGENCY_QUERY_KEY] })
    },
  })
}
